import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ServiceTemplateScheduleOccurrenceRow } from "../serviceTemplateScheduleOccurrencesViewConfig";
import { ServiceTemplateScheduleOccurrenceMemberCell } from "./ServiceTemplateScheduleOccurrenceMemberCell";

export const ServiceTemplateScheduleOccurrencePreparerCell = memo(
    ({
        row,
        table,
    }: CellContext<
        ViewTableFeatures,
        ServiceTemplateScheduleOccurrenceRow,
        number | null
    >) => (
        <ServiceTemplateScheduleOccurrenceMemberCell
            row={row}
            table={table}
            field="preparerId"
            addText="Assign preparer"
            emptyLabel="No preparer"
        />
    ),
);

ServiceTemplateScheduleOccurrencePreparerCell.displayName =
    "ServiceTemplateScheduleOccurrencePreparerCell";
